import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    currencyList: [],
};
const getters = {
    getCurrency: state => state.currencyList

};

const mutations = {
    CURRENCY_INFO(state, data) {
        state.currencyList = data
    }
};

const actions = {
    getCurrency({commit}) {
        axiosGet(`crm/currency/list`).then((response) => {
            commit('CURRENCY_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
